import { render } from "./promptDeskName.vue?vue&type=template&id=e824f930"
import script from "./promptDeskName.vue?vue&type=script&lang=js"
export * from "./promptDeskName.vue?vue&type=script&lang=js"

import "./promptDeskName.vue?vue&type=style&index=0&id=e824f930&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__